import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { DemographicsReportForm } from './components/DemographicsReportForm';
import { DemographicsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { DEMOGRAPHICS_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getDemographicsReport,
  getSiteGroupsAction,
  getGradesAction,
  clearReport,
} from './state/demographicsreport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReportGeneration } from 'Common/ObjectHelper';
import { createToast, toastType } from 'Common/ToastHelper';

class DemographicsReportContainer extends Component {
  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: DEMOGRAPHICS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getSiteGroupsAction();
    this.props.getGradesAction();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Demographics Report');
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    this.props.getDemographicsReport(formValues);
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Demographics Report'} />
        <Main {...this.getMainProps()}>
          <DemographicsReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.ProvisionType]: 'Both',
              [Fields.GroupBySiteGroup]: false,
              [Fields.ShowGradeDetailRows]: false,
              [Fields.AsOfDate]: defaultDateFormat(moment()),
              [Fields.SiteGroup]: 'ALL',
              [Fields.Site]: 'ALL',
              [Fields.Grade]: 'ALL',
            }}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.DemographicsReportState.demographics.loading,
    report: state.DemographicsReportState.demographics.report,
  };
};

export const Demographics = withRouter(
  connect(
    mapStateToProps,
    {
      getDemographicsReport,
      getSiteGroupsAction,
      getGradesAction,
      clearReport,
    }
  )(DemographicsReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/demographics/Demographics.js